import type { ComputedRef } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): ComputedRef<ITranslationsKeyMap> {
  return computed(() => ({
    affiliate: {
      creatives: {
        tabs: {
          link: 'TAB_LINK',
          jpeg: 'TAB_JPEG',
          png: 'TAB_PNG',
          gif: 'TAB_GIF',
          bannerflow_gif: 'TAB_BANNERFLOW_GIF',
          iframe: 'TAB_IFRAME',
          // flash: 'TAB_FLASH',
        },
        modal_window: {
          title: 'MODAL_TITLE',
          banner_code: 'MODAL_BANNER_CODE',
          zone_id: 'MODAL_ZONE_ID',
          redirect_link: 'MODAL_REDIRECT_LINK',
          integration_format: {
            label: 'MODAL_INTEGRATION_LABEL',
            url: 'MODAL_INTEGRATION_URL',
            url_js: 'MODAL_INTEGRATION_URL_JS',
          },
          button_copy: 'MODAL_COPY',
          button_cancel: 'MODAL_CANCEL',
        },
        header: 'HEADER',
        no_creatives: 'NO_CREATIVES',
        back: 'BACK',
      },
    },
  }));
}
